/**
 * User Domain Enums
 *
 * Shared enums used across client, admin, and edge apps.
 */

/**
 * User role for authorization
 */
export enum UserRole {
	Player = "player",
	Moderator = "moderator",
	Admin = "admin",
}

/**
 * Account status for user lifecycle management
 */
export enum AccountStatus {
	Active = "active",
	Suspended = "suspended",
	Deleted = "deleted",
}
